
export const DateInput = ({label, required, name, watch, setValue}:
  {label: string, required: boolean, name: string, watch: any, setValue: any}) => {
    let value = watch(name);
  return (
    <>
      <div className="flex items-center" style={{ marginBottom: 6 }}>
        <label htmlFor={name} className="block text-sm font-bold text-gray-800">
          {label}
        </label>
        {required &&
          <span className="ml-2 text-xs font-extrabold rounded px-1.5 py-0.5" style={{ color: "#FF4D2D", background: "#FFE9E1" }}>
            必須
          </span>
        }
      </div>
      <div className="flex">
        <input
          type="date"
          id={name}
          value={value !== undefined ? value.slice(0, -10) : new Date().toISOString().split('T')[0]} // T00:00:00Zを削除して代入している
          onChange={(e) => setValue(name, e.target.value + "T00:00:00Z")}
          className="h-11 px-2 focus:ring-[#FF4D2D] focus:border-[#FF4D2D] block w-full sm:text-sm border-gray-200 rounded-xl"
        />
      </div>
    </>
  )
}